var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',_vm._l((_vm.violation.links),function(link){return _c('li',{key:link.label},[_c('a',{attrs:{"href":link.href}},[_vm._v(_vm._s(link.label))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }